<template>
	<section class="start">
    <div class="start--wrapper">
      <div class="start-container">
        <div class="start--text">
          <h1>
            Chegou o Empiricus Pass Empresas
          </h1>
          <p>
            Um plano completo para você oferecer ao seu funcionário o benefício mais
            diferenciado de todo o mercado: a chance de ganhar mais dinheiro.
          </p>
          <v-btn class="start--cta-btn" @click="goToForm">
            <span>Fale com a gente</span>
            <i class="mdi mdi-chevron-right button"></i>
          </v-btn>
        </div>
      </div>
    </div>
  </section>
</template>
<script>

export default {
  methods: {
    goToForm () {
      const form = document.getElementById('contact')
      form.scrollIntoView({ behavior: 'smooth' })
    },
  }
}
</script>

<style lang="scss">
.start {
  background-color: var(--neutral-black-faq);
  display: flex;
  justify-content: center;
  width: 100%;

  &--wrapper {
    background-image: url('../../assets/images/banner/start-bg-extra-small.jpg');
    background-position: top;
    background-size: cover;
    display: flex;
    justify-content: center;
    margin-top: 60px;
    max-width: 1920px;
    width: 100%;

    @media only screen and (min-width: 600px) {
      background-image: url('../../assets/images/banner/start-bg.jpg');
      background-position: top;
      background-size: cover;
    }

    @media only screen and (min-width: 1024px) {
      margin-top: 72px;
    }
  }


  &-container {
    max-width: 1256px;
    padding: 278px 16px 40px 16px;
    width: 100%;

    @media only screen and (min-width: 600px) {
      padding: 154px 32px 176px 32px;
    }

    @media only screen and (min-width: 1024px) {
      padding: 149px 32px 141px 32px;
    }

    @media only screen and (min-width: 1440px) {
      padding: 236px 16px 235px 16px;
    }
  }

  &--text {
    h1 {
      color: var(--white);
      font-size: 2.0625rem;
      font-weight: 700;
      line-height: 38px;
      margin-bottom: 12px;
      width: 100%;

      @media only screen and (min-width: 600px) {
        font-size: 2.5rem;
        line-height: 44px;
        margin-bottom: 10px;
        max-width: 300px;
      }

      @media only screen and (min-width: 1024px) {
        font-size: 2.75rem;
        line-height: 50px;
        max-width: 410px;
      }
      @media only screen and (min-width: 1140px) {
        margin-bottom: 20px;
        max-width: 510px;
      }
    }

    p {
      color: var(--light-grey);
      font-family: var(--dm-sans-regular);
      font-size: .9375rem;
      line-height: 23px;
      margin-bottom: 20px;

      @media only screen and (min-width: 600px) {
        line-height: 21px;
        max-width: 360px;
      }

      @media only screen and (min-width: 1024px) {
        font-size: 1.125rem;
        line-height: 27px;
        max-width: 460px;
      }
      @media only screen and (min-width: 1140px) {
        font-size: 1.25rem;
        line-height: 30px;
      }
    }

    .start--cta-btn {
      background-color: var(--red) !important;
      color: var(--white) !important;
      font-family: var(--dm-sans-regular);
      font-size: .875rem;
      height: 44px !important;
      font-weight: 400;
      text-transform: unset !important;
      width: 100%;

      @media only screen and (min-width: 600px) {
        max-width: 176px;
      }

      @media only screen and (min-width: 1024px) {
        font-size: 1rem;
        height: 48px !important;
        max-width: 196px;
      }

      @media only screen and (min-width: 1440px) {
        font-size: 1.125rem;
        height: 56px !important;
        max-width: 224px;
      }

      i {
        margin-top: 4px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Section/Section1.vue